import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2 className="text-center lg:text-4xl md:text-2xl text-xl">
        Opps!Page not Found..!!
      </h2>
    </div>
  );
};

export default NotFound;
